export default "__VITE_ASSET__DEbEjcVd__"